<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="images" src="images/f012-01.jpg" width="80%"/></p>
<p class="caption"><em class="italic">Many Portuguese headstones are in a very poor condition. Fortunately, this headstone commemorating the death in 1917 of</em> Soldado <em class="italic">Joaquim da Silva is still legible</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 15_fm0210.vue?39ff884d